import { useState, useEffect } from 'react';
import debounce from 'lodash.debounce';

export function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const debouncedSetter = debounce(() => {
      setDebouncedValue(value);
    }, delay);

    debouncedSetter(); // Call the debounced function

    return () => {
      debouncedSetter.cancel(); // Cancel the debounced call
    };
  }, [value, delay]);

  return debouncedValue;
}
